import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import styled, { css } from 'styled-components';
import SwipeableViews from 'react-swipeable-views';
import withMatch from '@/hocs/withMatch';
import ObserveSize from './ObserveSize';
import HouseCard from './HouseCard';
import BBCode from './shared/richText/BBCode';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
import ButtonPrimary from './shared/buttons/ButtonPrimary';
import { colorPalette, textStyles } from '../styles/styleGuide';
import Caret from './shared/icons/Caret';
var HouseTypeCarousel = /*#__PURE__*/function (_React$PureComponent) {
  function HouseTypeCarousel() {
    var _this;
    _classCallCheck(this, HouseTypeCarousel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HouseTypeCarousel, [].concat(args));
    _defineProperty(_this, "state", {
      swipeIndex: 0,
      renderWidth: 0
    });
    _defineProperty(_this, "handleChangeIndex", function (index) {
      _this.setState({
        swipeIndex: index
      });
    });
    _defineProperty(_this, "renderHouseCardView", function (_ref) {
      var availableCount = _ref.availableCount,
        bedrooms = _ref.bedrooms,
        energyLabel = _ref.energyLabel,
        isSold = _ref.isSold,
        livingSpace = _ref.livingSpace,
        slug = _ref.slug,
        media = _ref.media,
        optionCount = _ref.optionCount,
        price = _ref.price,
        totalCount = _ref.totalCount,
        variantCodes = _ref.variantCodes,
        variantName = _ref.variantName;
      return __jsx(HouseCard, {
        availableCount: availableCount,
        bedrooms: bedrooms,
        energyLabel: energyLabel,
        isSold: isSold,
        livingSpace: livingSpace,
        media: media,
        optionCount: optionCount,
        price: price,
        slug: slug,
        totalCount: totalCount,
        variantCodes: variantCodes,
        variantName: variantName,
        "data-id": "components_HouseTypeCarousel_HouseCard"
      });
    });
    return _this;
  }
  _inherits(HouseTypeCarousel, _React$PureComponent);
  return _createClass(HouseTypeCarousel, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        title = _this$props.title,
        bbcode = _this$props.bbcode,
        houseTypes = _this$props.houseTypes,
        link = _this$props.link,
        label = _this$props.label;
      var _this$state = this.state,
        renderWidth = _this$state.renderWidth,
        swipeIndex = _this$state.swipeIndex;
      var swipeView = renderWidth < 680;
      var mediumView = renderWidth >= 680 && renderWidth < 1027;
      var largeView = renderWidth >= 1027;
      var xLargeView = window.innerWidth - renderWidth > 140;
      return __jsx(HouseTypeBlock, {
        largeView: largeView,
        "data-e2e-block-housetypecarousel": true,
        "data-id": "components_HouseTypeCarousel_HouseTypeBlock"
      }, __jsx(ObserveSize, {
        observerFn: function observerFn(contentRect) {
          return _this2.setState({
            renderWidth: contentRect.width
          });
        },
        "data-id": "components_HouseTypeCarousel_ObserveSize"
      }, title && __jsx(Title, {
        "data-id": "components_HouseTypeCarousel_Title"
      }, title), bbcode && __jsx(Description, {
        "data-id": "components_HouseTypeCarousel_Description"
      }, __jsx(BBCode, {
        content: bbcode,
        "data-id": "components_HouseTypeCarousel_BBCode"
      })), __jsx(HouseCardRow, {
        swipeView: swipeView,
        mediumView: mediumView,
        largeView: largeView,
        xLargeView: xLargeView,
        "data-id": "components_HouseTypeCarousel_HouseCardRow"
      }, __jsx(SwipeableViews, {
        style: swipeView ? {
          padding: '0',
          overflow: 'visible',
          overflowX: 'visible'
        } : mediumView ? {
          width: '50%',
          overflow: 'visible',
          overflowX: 'visible'
        } : {
          width: '33.333%',
          overflow: 'visible',
          overflowX: 'visible'
        },
        onChangeIndex: this.handleChangeIndex,
        index: swipeIndex,
        slideStyle: swipeView ? {
          overflow: 'visible',
          overflowX: 'visible',
          padding: '0 5px',
          boxSizing: 'border-box'
        } : {
          overflow: 'visible',
          overflowX: 'visible',
          padding: '0 10px',
          boxSizing: 'border-box'
        },
        ignoreNativeScroll: true,
        "data-id": "components_HouseTypeCarousel_SwipeableViews"
      }, houseTypes && houseTypes.map(function (houseType, index) {
        return __jsx(HousCardWrapper, {
          key: index,
          "data-id": "components_HouseTypeCarousel_HousCardWrapper"
        }, _this2.renderHouseCardView(houseType));
      })), !swipeView && __jsx(ArrowPrimaryNext, {
        key: "next",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: _this2.state.swipeIndex + 1
          });
        },
        disabled: !houseTypes || swipeIndex >= (mediumView ? houseTypes.length - 2 : houseTypes.length - 3),
        "data-id": "components_HouseTypeCarousel_ArrowPrimaryNext"
      }, __jsx(Caret, {
        direction: "right",
        color: colorPalette.white,
        "data-id": "components_HouseTypeCarousel_Caret"
      })), !swipeView && __jsx(ArrowPrimaryPrev, {
        key: "prev",
        onClick: function onClick() {
          return _this2.setState({
            swipeIndex: swipeIndex - 1
          });
        },
        disabled: !houseTypes || swipeIndex === 0,
        "data-id": "components_HouseTypeCarousel_ArrowPrimaryPrev"
      }, __jsx(Caret, {
        direction: "left",
        color: colorPalette.white,
        "data-id": "components_HouseTypeCarousel_Caret"
      })))), link && link !== null && __jsx(ButtonWrapper, {
        "data-id": "components_HouseTypeCarousel_ButtonWrapper"
      }, __jsx(ButtonPrimary, {
        label: label || '',
        link: '/' + getLinkFromPageObject(link),
        type: "internalLink",
        "data-id": "components_HouseTypeCarousel_ButtonPrimary"
      })));
    }
  }]);
}(React.PureComponent);
export default withMatch(HouseTypeCarousel);
var Title = styled.h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var Description = styled.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 35rem;\n  max-width: 780rem;\n"])));
var HousCardWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));
var HouseCardRow = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 40rem;\n  display: flex;\n  box-sizing: border-box;\n  flex-flow: row wrap;\n  position: relative;\n\n  > div {\n    width: 100%;\n  }\n\n  > div > div {\n    height: 100%;\n  }\n\n  > div > div > div {\n    height: 100%;\n    box-sizing: border-box;\n    transition: opacity 0.4s ease-in-out;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.mediumView ? "\n    width: calc(100% - 100rem);\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 815rem;\n\n    > div > div > div {\n      opacity: 0;\n      pointer-events: none;\n\n      &[aria-hidden=\"false\"], &[aria-hidden=\"false\"] + div {\n        pointer-events: auto;\n        opacity: 1;\n      }\n    }\n  " : '';
}, function (props) {
  return props.largeView ? "\n    width: calc(100% - 120rem);\n    margin-left: auto;\n    margin-right: auto;\n\n        > div > div > div {\n          opacity: 0;\n          pointer-events: none;\n\n          &[aria-hidden=\"false\"], &[aria-hidden=\"false\"] + div,  &[aria-hidden=\"false\"] + div + div {\n            pointer-events: auto;\n            opacity: 1;\n          }\n        }\n\n  " : '';
}, function (props) {
  return props.xLargeView ? "\n    width: calc(100% + 20rem);\n    left: -10rem;\n  " : '';
});
var ArrowStyle = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 45%;\n  transform: translateY(-50%);\n  z-index: 1;\n  opacity: 0.85;\n  background-color: ", ";\n  width: 40rem;\n  height: 40rem;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  ", ";\n"])), colorPalette.lightBeige, function (props) {
  return props.disabled ? 'opacity: 0; pointer-events: none;' : ' &:hover { opacity: 1; } ';
});
var ArrowPrimaryNext = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", " right: -50rem;\n"])), ArrowStyle);
var ArrowPrimaryPrev = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", " left: -50rem;\n"])), ArrowStyle);
var HouseTypeBlock = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (props) {
  return props.largeView ? "\n    margin-bottom: 60rem;\n  " : "\n    margin-bottom: 40rem;\n  ";
});
var ButtonWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  text-align: center;\n  > a {\n    padding-left: 30rem;\n    padding-right: 30rem;\n  }\n"])));